// Generated by CoffeeScript 1.9.1
var FeatureCol, Model, Sequence;
Model = require("backbone-thin").Model;
FeatureCol = require("./FeatureCol");
module.exports = Sequence = Model.extend({
  defaults: {
    name: "",
    id: "",
    seq: "",
    height: 1,
    ref: false
  },
  initialize: function initialize() {
    this.set("grey", []);
    if (this.get("features") == null) {
      return this.set("features", new FeatureCol());
    }
  }
});